import React from 'react';
import isString from "lodash/isString";
import { logDeprecationMessage } from '@jutro/platform';
export function resolveComponentFromMap(component, componentMap = {}) {
  if (isString(component)) {
    let resolvedComponent = componentMap[component];
    if (!resolvedComponent) {
      logDeprecationMessage('Support for componentMaps with case-insensitive keys', 'Adjust the keys in your componentMap to match the name of the component');
      resolvedComponent = componentMap[component.toLowerCase()];
    }
    return resolvedComponent;
  }
  return component;
}